// data/etablissementData.js

export const etablissementData = [
  {
    id: 1,
    nom: "Lycée Jean Moulin",
    adresse: "12 rue des écoles, 75000 Paris",
    email: "contact@lycee-moulin.fr",
    telephone: "01 23 45 67 89",
    abonnement: "Formule Premium",
    statut: "Actif",
    dateExpiration: "2026-01-01",
    historique: [
      {
        date: "2024-05-01",
        ancienne: "Formule Basique",
        nouvelle: "Formule Premium",
        mode: "immediat",
      },
    ],
  },
  {
    id: 2,
    nom: "Collège Victor Hugo",
    adresse: "8 avenue de la République, 69000 Lyon",
    email: "contact@college-hugo.fr",
    telephone: "04 78 12 34 56",
    abonnement: "Formule Basique",
    statut: "Inactif",
    dateExpiration: "2024-12-31",
    historique: [],
  },
  {
    id: 3,
    nom: "École Élémentaire Pasteur",
    adresse: "5 rue des Lilas, 33000 Bordeaux",
    email: "contact@ecole-pasteur.fr",
    telephone: "05 56 78 90 12",
    abonnement: "Formule IA",
    statut: "Actif",
    dateExpiration: "2025-07-01",
    historique: [
      {
        date: "2025-01-10",
        ancienne: "Formule Premium",
        nouvelle: "Formule IA",
        mode: "prochaine_echeance",
      },
    ],
  },
];
